import Header from './header';

const headerConfig = {
  name: 'siteHeader',
  class: Header,
  querySelector: {},
  querySelectorAll: {},
  options: {},
};

export default headerConfig;



// WEBPACK FOOTER //
// ./client/src/components/header/index.js